<div class="col">
  <div class="card">
    <div class="card-body">
      <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
        <ol class="carousel-indicators">
          <li *ngFor="let news of newsItems; let i = index" 
              [attr.data-bs-target]="'#carouselExampleCaptions'" 
              [attr.data-bs-slide-to]="i" 
              [class.active]="i === 0">
          </li>
        </ol>
        <div class="carousel-inner">
          <div *ngFor="let news of newsItems; let i = index" 
               class="carousel-item" 
               [class.active]="i === 0">
            <img [src]="news.image" class="d-block w-100" alt="...">
            <div class="carousel-caption d-none d-md-block">
              <h5>{{ news.titlePart1 }}</h5>
              <p>{{ news.description }}</p>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
      </div>
    </div>
  </div>
</div>

  
  <div>
    <div style="display: flex; justify-content: space-between; margin-left: 35%;  margin-right: 35%;" *ngIf="firstItem">
      <div style="width: 120px; height: 14px; background-color: black; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
    </div>
  
    <div style="display: flex; justify-content: space-between; margin-left: 35%;  margin-right: 35%;" *ngIf="secondItem">
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: black; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
    </div>
  
    <div style="display: flex; justify-content: space-between; margin-left: 35%;  margin-right: 35%;" *ngIf="thirdItem">
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: gray; border-radius: 10px;"></div>
      <div style="width: 120px; height: 14px; background-color: black; border-radius: 10px;"></div>
    </div>
   </div>
  